export default __webpack_public_path__ + "static/media/group480879-ci.a07a9298.svg";